var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: `${_vm.width}px`, height: `${_vm.height}px`})},[_c('iframe',{attrs:{"src":"https://cdn.lottielab.com/l/7CGMPM6d2jr7oE.html","frameborder":"0","width":"100%","height":"100%","allow":"autoplay","title":"No Brand Favorites Animation"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }